// extracted by mini-css-extract-plugin
module.exports = {"w1y2d26q":"w1y2d26q","t1qrw86x":"t1qrw86x"};